import { z } from 'zod';

export const ruleSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'نام قانون الزامی است')
    .max(100, 'نام بسیار طولانی است'),
  rule_type: z.string().min(1, 'نوع قانون الزامی است'),
  severity: z.string().min(1, 'سطح اهمیت الزامی است'),
  metric_name: z.string().optional(),
  operator: z.string().optional(),
  value: z.union([z.string(), z.number()]).optional(),
  value2: z.union([z.string(), z.number()]).optional(),
  duration_seconds: z.union([z.string(), z.number()]).optional(),
  is_active: z.boolean().optional(),
});

export const createRuleSchema = ruleSchema.extend({
  target_type: z.string().min(1, 'نوع هدف الزامی است'),
  target_eui: z.string().optional(),
  target_tag_id: z.string().optional(),
  channel_id: z.string().min(1, 'انتخاب کانال الزامی است'),
});
